











































































import _ from 'lodash'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { Getter, State, Action, Mutation } from 'vuex-class'
import { RootState } from '@/store/types'
import { EditorEntry } from '@/store/editor/types'
import { Maybe } from '@/types/general'
import Search from '@/util/Search'
import Entry from '@/data/entry-model'
import { ENTRY_UPDATE, EDITOR_SET_VAULT, EDITOR_SET_TOP_LEVEL } from '@/store/editor/constants'

const VaultSelectorItem = () => import('./VaultSelectorItem.vue')

@Component({ name: 'vault-selector', components: { VaultSelectorItem } })
export default class VaultSelector extends Vue {
    editing: boolean = false

    stretchWidth: number = 100

    searchTerm: string = ''

    @Prop({ type: String, default: 'lg' })
    size!: string

    /**
     * Commit the change to the entry
     */
    @Action(ENTRY_UPDATE)
    updateEntry!: () => Promise<void>

    /**
     * Set entry vault
     */
    @Mutation(EDITOR_SET_VAULT)
    setVault!: (id: string) => void

    @State((state: RootState) => state.editor.entry)
    entry!: EditorEntry

    /**
     * Toggle the entry as 'top level' - parentless
     *
     * Only used for vaults
     */
    @Mutation(EDITOR_SET_TOP_LEVEL)
    setTopLevel!: (value: boolean) => void

    @Getter
    getEntry!: (entry: string | Entry) => Entry

    @Getter
    topLevelEntries!: Entry[]

    get existing(): boolean {
        return this.entry.existing
    }

    get isVault(): boolean {
        return this.entry.schema === 'vault'
    }

    get vault(): Maybe<Entry> {
        if (!this.entry.vault) {
            return undefined
        }
        return this.getEntry(this.entry.vault)
    }

    get path(): string[] {
        if (!this.vault) {
            return [this.isVault ? 'root' : 'no vault selected']
        }
        return this.vault.titlePath
    }

    get topVaults(): Entry[] {
        return this.topLevelEntries
            .filter(entry => entry.isVault())
            .filter(entry => !this.searchTerm || Search.score(this.searchTerm, entry))
    }

    get error(): string {
        return this.entry.vaultError || ''
    }

    updateSearchTerm(value: string): void {
        this.searchTerm = value
        this.$nextTick(() => {
            this.stretchWidth = (this.$refs.sizer as HTMLElement).clientWidth + 32
            if (this.stretchWidth < 100) {
                this.stretchWidth = 100
            }
        })
    }

    update(vaultId: string): void {
        if (vaultId === '') {
            this.setTopLevel(true)
        } else {
            this.setVault(vaultId)
        }
        if (this.existing) {
            this.updateEntry()
        }
        this.stopEditing()
    }

    focusInput(): void {
        if (this.$refs.input) {
            (this.$refs.input as HTMLElement).focus()
        }
    }

    startEditing(event: MouseEvent): void {
        this.editing = true
        this.searchTerm = ''
        this.$nextTick(() => {
            this.focusInput()
            window.addEventListener('click', this.stopEditing)
        })
        event.preventDefault()
        event.stopPropagation()
    }

    stopEditing(): void {
        this.editing = false
        this.searchTerm = ''
        window.removeEventListener('click', this.stopEditing)
    }
}
